import React from 'react';
import { dispatch } from 'nike-re-framejs';
import Immutable from 'immutable';
import i18n from '@i18n';
import { sendCmd } from '@/betslip/handlers';
import { isSelectionSelected$$ } from '@/betslip/subs';
import PopupNg from '@/ui/PopupNg';
import forumClient from '@/_http/axiosForumClient';
import n1Client from '@/_http/axiosN1Client';
import ticketusClient from '@/_http/axiosTicketusClient';
import TicketsOverview from '@/mytickets/overview/views/TicketsOverview';
import MarketStatisticsHolder from '@/market-statistics';
import useMatchNotification from '@/notifications/components/useMatchNotification';
import BetLocationContext, { betLocation } from 'nike-ui/src/common/BetLocationContext';
import BetbookAnalysisItem from '@/betbook/views/BetbookAnalysisItem';

export const turboLiveContextValue = {
    addPick: (betId, selectionCode, odds, sectionOrigin, additionalAction?) => {
        sendCmd([
            'AddPickMobile',
            { betId, selectionCode, odds, positionId: sectionOrigin?.id, positionCode: sectionOrigin?.code }
        ]);
        if (additionalAction) additionalAction();
    },
    removePick: betId => sendCmd(['RemovePick', { betId }]),
    isPickSelectedSub$$: (betId, selectionCode) => isSelectionSelected$$(betId, selectionCode),
    showLoginModal: () => {
        PopupNg.dispatcher.open('dialog/login4action', { bodyText: i18n('favourite.notloggedin') });
    },
    startCashinOfferSubscription: () => {
        dispatch(['ticketus/cashin-offer/subscribe']);
    },
    stopCashinOfferSubscription: () => {
        dispatch(['ticketus/cashin-offer/unsubscribe']);
    },
    openCashinDialog: (ticketId, ref, cashinPosition) => {
        PopupNg.dispatcher.open('ticketus/cashin-dialog', Immutable.fromJS({ ticketId, cashinPosition }));
    },
    openAutoCashinDialog: (ticketId, ref, cashinPosition) => {
        PopupNg.dispatcher.open('cashin/auto-cashin-dialog', { ticketId: ticketId, cashinPosition });
    },
    startBetradarMT: () => {},
    startStream: () => {},
    getBetbookPosts: matchId => forumClient.get('/v5/betbook/analyses', { params: { count: 100, matchId } }),
    getNextMatchData: () => n1Client.get('/v1/next-match'),
    getActiveTickets: () => ticketusClient.get('tickets/active'),
    getActiveMatchTickets: matchId =>
        ticketusClient.get('tickets/active-on-match', { params: { sportEventId: matchId } }),
    ticketsTable: matchId => (
        <BetLocationContext.Provider value={{ betLocationSection: betLocation.TURBOLIVE_TICKET_LIST }}>
            <TicketsOverview matchId={matchId} showHeader={false} autoHeight />
        </BetLocationContext.Provider>
    ),
    marketStatisticsBox: (matchId, sportId, live, market) => (
        <BetLocationContext.Provider value={{ betLocationSection: betLocation.TURBOLIVE_DETAIL_OSTATNI_TIPUJU }}>
            {/*@ts-expect-error typescript*/}
            <MarketStatisticsHolder sportId={sportId} live={live} market={market} matchId={matchId} />
        </BetLocationContext.Provider>
    ),
    betbookPostsBox: (post, detail) => <BetbookAnalysisItem post={post} detail={detail} />,
    MatchNotificationBox: (matchId, sportId) => useMatchNotification(matchId),
    showTooltip: text => PopupNg.dispatcher.open('dialog/message', { bodyText: text })
};
